export const OrderTypes = {
    Asc: 'ASC',
    Desc: 'DESC',
}
